const baseConfig = {
  baseServerUrl: '',
  bot: ''
}
if(process.env.NODE_ENV === 'production' && process.env.VUE_APP_TITLE === 'test') {
  baseConfig.baseServerUrl = 'https://8t6rd6i.cnyideng.com/appjmall/api';
  baseConfig.bot = 'jmallbot'
} else if(process.env.NODE_ENV === 'development') {
  baseConfig.baseServerUrl = '/api/appjmall/api'
} else {
  baseConfig.bot = 'yoyoyokobot'
  baseConfig.baseServerUrl = 'https://no5.kopdeouy.xyz/appjmall/api'
}

export default baseConfig;